import { appInfo } from "@/common/data/appinfo";
export default [
  {
    path: "/B47fcb01a0a0740105e9f7a5133QWSp",
    children: [
      {
        path: "Nv95pfefdd65b681c99782a11e40e9axqHkUfB",
        name: "course.comments",
        meta: {
          title: `${appInfo?.type == "codsms" ? "Subject" : "Course"} Comments`,
          authRequired: true,
          acc: ["y132838"],
        },
        component: () => import("@/views/course-comment/index.vue"),
      },
      {
        path: "L23fdfe6126d3b6e1186d5ab5ab81wYxW",
        name: "course.comment.add",
        meta: {
          title: `Add ${
            appInfo?.type == "codsms" ? "Subject" : "Course"
          } Comment`,
          authRequired: true,
          acc: ["y1329138"],
        },
        component: () => import("@/views/course-comment/upload.vue"),
      },
    ],
  },
];
